import React from "react";

import { GridToolbarContainer } from "@mui/x-data-grid";
import { ButtonGroup } from "react-bootstrap";
import {
  Button,
  TextField,
  Select,
  MenuItem,
  Chip,
  Box,
  IconButton,
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";

import { TbFileImport } from "react-icons/tb";
import { TfiImport } from "react-icons/tfi";

import { getColorFromName } from "../utils/ownerColors";

export default function CustomToolbar({
  debouncedSearch,
  handleAddRow,
  handleExport,
  ownerFilter,
  setOwnerFilter,
  ownerList = [],
  rows = [],
  columns = [],
  setFilterModel,
  openFilter,
  setCarrierDialog,
  handleImport,
  downloadSampleExcel,
}) {
  const [field, setField] = React.useState("");
  const [operator, setOperator] = React.useState("contains");
  const [value, setValue] = React.useState("");

  const colors = [
    "#1976d2",
    "#9c27b0",
    "#2e7d32",
    "#ed6c02",
    "#d32f2f",
    "#0288d1",
    "#7b1fa2",
    "#388e3c",
    "#f57c00",
  ];

  const getColorFromName = (name = "") => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash % colors.length)];
  };

  const applyFilter = () => {
    if (!field) return;

    const selectedColumn = columns.find((c) => c.field === field);

    let finalOperator = operator;

    // ✅ FIX FOR SINGLE SELECT COLUMNS
    if (selectedColumn?.type === "singleSelect") {
      finalOperator = "is";
    }

    setFilterModel({
      items: [
        {
          id: 1,
          field,
          operator: finalOperator,
          value,
        },
      ],
    });
  };

  return (
    <GridToolbarContainer>
      <ButtonGroup style={{ border: "1px solid #0085dd" }}>
        <Button
          onClick={handleAddRow}
          style={{
            backgroundColor: "#0085dd",
            color: "#fff",
            borderTopRightRadius: "0px",
            borderBottomRightRadius: "0px",
            display: "block",
          }}
        >
          Add Record
        </Button>

        <Button component="label">
          <TbFileImport style={{ fontSize: "20px" }} />
          <input
            type="file"
            hidden
            accept=".xlsx,.xls,.csv"
            onChange={handleImport}
          />
        </Button>

        <Button onClick={downloadSampleExcel}>
          <TfiImport style={{ fontSize: "18px" }} />
        </Button>
      </ButtonGroup>

      <TextField
        size="small"
        placeholder="Search..."
        onChange={(e) => debouncedSearch(e.target.value)}
        sx={{ ml: 2, width: 250 }}
      />

      <Button onClick={handleExport}>Export CSV</Button>

      {/* OWNER FILTER */}
      <Select
        multiple
        size="small"
        value={ownerFilter}
        onChange={(e) => {
          const value = e.target.value;
          setOwnerFilter(typeof value === "string" ? value.split(",") : value);
        }}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {selected.map((owner) => {
              const fullName =
                rows.find((r) => r.owner_id === owner)?.owner_name || owner;

              const initials = fullName
                ?.split(" ")
                .map((n) => n[0])
                .join("")
                .toUpperCase();

              return (
                <Chip
                  key={owner}
                  label={
                    rows.find((r) => r.owner_id === owner)?.owner_name || owner
                  }
                  avatar={
                    <Box
                      sx={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        backgroundColor: getColorFromName(fullName),
                        color: "#fff !important",
                        fontSize: 11,
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {initials}
                    </Box>
                  }
                />
              );
            })}
          </Box>
        )}
        sx={{ ml: 2, minWidth: 250 }}
      >
        {ownerList.map((owner) => {
          const fullName =
            rows.find((r) => r.owner_id === owner)?.owner_name || owner;
          const initials = fullName
            ?.split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase();

          return (
            <MenuItem key={owner} value={owner}>
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  backgroundColor: getColorFromName(fullName),
                  color: "#fff !important",
                  fontSize: 12,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 1,
                }}
              >
                {initials}
              </Box>

              {rows.find((r) => r.owner_id === owner)?.owner_name || owner}
            </MenuItem>
          );
        })}
      </Select>

      <IconButton sx={{ ml: 1 }} onClick={openFilter}>
        <FilterListIcon />
      </IconButton>
    </GridToolbarContainer>
  );
}
